<template>
  <div class="page_staging">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>工作台</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs" v-if="isOpen">
        <!-- <div @click="sendMessage">aaa</div> -->
        <!-- 通知 -->
        <div class="notice-wrapper" v-if="tipsVisible">
          <!-- 左侧固定图标 -->
          <div class="notice-icon">
            📢 <span>通知</span>
          </div>

          <!-- 滚动区域 -->
          <div class="scroll-wrap" ref="scrollWrap" @mouseenter="pause()" @mouseleave="resume()">
            <div class="scroll-content" ref="scrollContent" :style="{ transform: `translateX(${position}px)` }">
              {{ displayText }}
            </div>
          </div>

          <!-- 关闭按钮 -->
          <button class="notice-close" @click="handleClose">✕</button>
        </div>

        <div class="flex" style="margin-top: 20px;">
          <div class="left_box">
            <!-- 任务看板 -->
            <div class="stagingBox" v-loading="taskLoading">
              <div class="messageTitle">任务看板</div>
              <div class="flex sb">
                <el-tabs v-model="BusiType" @tab-click="changeTab">
                  <el-tab-pane label="今日待办" name="1"></el-tab-pane>
                  <el-tab-pane label="明日待办" name="2"></el-tab-pane>
                  <el-tab-pane label="7日待办" name="3"></el-tab-pane>
                  <el-tab-pane label="已办" name="4"></el-tab-pane>
                  <el-tab-pane label="过期" name="5"></el-tab-pane>
                </el-tabs>
                <div class="taskR aic">
                  <div class="taskIconItem cp" @click="assignTasks">
                    <i class="fas fa-tasks"></i>
                    安排任务
                  </div>
                  <div class="taskIconItem cp" @click="setTaskList">
                    <i class="fas fa-user-lock"></i>
                    权限设置
                  </div>
                  <div class="taskIconItem cp" @click="toSysSet" v-if="roleName.indexOf('管理员') > -1">
                    <i class="fas fa-layer-group"></i>
                    系统模板设置
                  </div>
                </div>
              </div>
              <div class="dataBoard">
                <div class="taskItem cp" v-for="(item, index) in taskList" :key="index" @click="toTaskItem(item)">
                  <div>
                    <div class="custNum" v-if="item.busiId=='4'">{{ Number(item.val).toLocaleString() }}</div>
                    <div class="AINum" v-else-if="item.busiId=='6'">{{ Number(item.val).toLocaleString() }}</div>
                    <div class="taskNum" v-else>{{ item.val ? Number(item.val).toLocaleString() : 0}}</div>
                  </div>
                  <div class="taskTitle">{{ item.busiName }}</div>
                </div>
              </div>
              <div v-if="taskList.length == 0 && !taskLoading">
                <!-- <el-empty description="暂无任务"></el-empty> -->
                <div class="emptyTip">
                  <i class="fas fa-clipboard-check" style="color:#19bd92;"></i> 暂无任务
                </div>
              </div>
            </div>

            <!-- 工作流 -->
            <div class="stagingBox" v-loading="loading">
              <div class="messageTitle">待办事项</div>
              <div class="flex tabbox">
                <el-tabs v-model="activeName" @tab-click="handleClick">
                  <el-tab-pane :label="'待审批（' + Todolist_EmpWorks + '）'" name="1"></el-tab-pane>
                  <el-tab-pane label="已审批" name="2"></el-tab-pane>
                  <el-tab-pane label="我发起的" name="3"></el-tab-pane>
                </el-tabs>
                <el-input v-model="listQuery.key" placeholder="搜索" prefix-icon="el-icon-search" size="small" style="width: 200px;" clearable @blur="searchHandle"></el-input>
              </div>
              <div class="approveBox" v-if="remainData.length > 0">
                <div class="approveItem cp" v-for="(item, index) in remainData" :key="index" @click="toHandel(item)">
                  <span class="approveTitle warning" v-if="activeName=='1'">审批</span>
                  <span class="approveTitle success" v-if="activeName=='2'">已审批</span>
                  <span :class="item.FK_Flow=='1' ? 'approveTitle success' : 'approveTitle warning'" v-if="activeName=='3'">{{item.FK_Flow=='1' ? '已审批' : '审批'}}</span>
                  <span>{{ item.Title }}</span>
                  <span v-if="activeName=='1'">的流程待审批，请及时处理</span>
                </div>
                <div class="block">
                  <el-pagination v-if="totalcount>0" @current-change="currentChange" :current-page.sync="listQuery.pageNum" :page-size="Number(listQuery.pageSize)" layout="total,prev,pager, next" :total="totalcount"></el-pagination>
                </div>
              </div>
              <div v-else>
                <!-- <el-empty description="暂无待办事项"></el-empty> -->
                <div class="emptyTip">
                  <i class="fas fa-check-circle" style="color:#19bd92;"></i> 暂无待办事项
                </div>
              </div>
            </div>

            <!-- 消息通知 -->
            <div class="stagingBox">
              <div class="flex tabbox">
                <div class="messageTitle" style="margin-bottom: 30px;">消息通知</div>
                <el-input v-model="listQuery.name" placeholder="搜索" size="small" style="width: 200px;" clearable></el-input>
              </div>
              <!-- <div class="approveBox">
              <div class="approveItem cp" v-for="(item, index) in 8" :key="index">
                《XXXX项目》【发薪】已完成，应发12人，实发10人，请知悉。 2023/12/23 09:03:02
              </div>
            </div> -->
              <!-- <div>
                <el-empty description="暂无消息通知"></el-empty>
              </div> -->
              <div class="emptyTip">
                <i class="fas fa-inbox" style="color:#19bd92;"></i> 暂无消息通知
              </div>
            </div>
          </div>
          <div class="right_box">
            <!-- 数据面板 -->
            <div class="shortcuts">
              <el-tabs v-model="activeName2" @tab-click="handleClickShortcuts">
                <el-tab-pane label="客服数据" name="2" v-if="roleName != undefined && (roleName.indexOf('客服') > -1 || roleName.indexOf('管理员') > -1)">
                  <div class="dataBoard">
                    <div class="dataItem cp" v-for="(item, index) in list3" :key="index" @click="toSignupList">
                      <div class="dataNum">{{ numList[item.num] ? Number(numList[item.num]).toLocaleString() : 0 }}</div>
                      <div class="dataTitle">{{ item.title }}</div>
                    </div>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="招聘数据" name="1" v-if="roleName != undefined && (roleName.indexOf('招聘') > -1 || roleName.indexOf('管理员') > -1)">
                  <div class="dataBoard">
                    <div class="dataItem cp" v-for="(item, index) in list" :key="index" @click="toSignupList">
                      <div class="dataNum">{{ numList[item.num] ? Number(numList[item.num]).toLocaleString() : 0 }}</div>
                      <div class="dataTitle">{{ item.title }}</div>
                    </div>
                  </div>
                </el-tab-pane>

                <el-tab-pane label="业务数据" name="3" v-if="roleName != undefined && (roleName.indexOf('业务') > -1 || roleName.indexOf('管理员') > -1)">
                  <div class="dataBoard">
                    <div class="dataItem cp" v-for="(item, index) in list3" :key="index" @click="toSignupList">
                      <div class="dataNum">{{ numList[item.num] ? Number(numList[item.num]).toLocaleString() : 0 }}</div>
                      <div class="dataTitle">{{ item.title }}</div>
                    </div>
                  </div>
                </el-tab-pane>

                <el-tab-pane label="统计数据" name="4" v-if="roleName != undefined && (roleName.indexOf('客服') == -1 && roleName.indexOf('管理员') == -1 && roleName.indexOf('业务') == -1 && roleName.indexOf('招聘') == -1)">
                  <div class="dataBoard">
                    <div class="dataItem cp" v-for="(item, index) in list3" :key="index" @click="toSignupList">
                      <div class="dataNum">{{ Number(numList[item.num]).toLocaleString() }}</div>
                      <div class="dataTitle">{{ item.title }}</div>
                    </div>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
            <!-- 快捷入口 -->
            <div class="shortcuts">
              <div class="messageTitle">快捷入口</div>
              <div class="quick_grid">
                <div class="quick_item cp" v-for="(item, index) in shortcutList" :key="index" @click="goto(item.path)">
                  <div class="iconBox">
                    <i :class="item.icon"></i>
                  </div>
                  <div class="dataTitle">{{ item.name }}</div>
                </div>
                <div class="quick_item cp" @click="gotoOut()" v-if="checkPermission(['table_Data_driver1'], permissionLists)">
                  <div class="iconBox">
                    <i class="fas fa-chart-line"></i>
                  </div>
                  <div class="dataTitle">数据驾驶舱</div>
                </div>
                <div class="quick_item cp" @click="goto('/tePaymentList')" v-if="isTest">
                  <div class="iconBox">
                    <i class="fas fa-hand-holding-usd"></i>
                  </div>
                  <div class="dataTitle">暂支</div>
                </div>
                <div class="quick_item cp" @click="goto('/workLog')" v-if="isTest">
                  <div class="iconBox">
                    <i class="fas fa-clipboard-list"></i>
                  </div>
                  <div class="dataTitle">工作日志</div>
                </div>
                <div class="quick_item cp" @click="goto('/finSet')" v-if="roleName.indexOf('管理员') > -1">
                  <div class="iconBox">
                    <i class="fas fa-cog"></i>
                  </div>
                  <div class="dataTitle">财务设置</div>
                </div>
                <div class="quick_item cp" @click="gotoOut2()">
                  <div class="iconBox">
                    <i class="fas fa-briefcase"></i>
                  </div>
                  <div class="dataTitle">业务-客户管理</div>
                </div>
                <div class="quick_item cp" @click="gotoOutSSC()" v-if="checkPermission(['table_Data_driver1'], permissionLists)">
                  <div class="iconBox">
                    <i class="fas fa-handshake"></i>
                  </div>
                  <div class="dataTitle">智慧共享服务中心</div>
                </div>
                <!-- <div class="quick_item cp" @click="gotoQKL()" v-if="roletype == '0383e791-72fd-4edc-aa70-2bcadminuser'">
                  <div class="iconBox">
                    <i class="fas fa-handshake"></i>
                  </div>
                  <div class="dataTitle">区块链</div>
                </div>
                <div class="quick_item cp" @click="gotoHLS()" v-if="roletype == '0383e791-72fd-4edc-aa70-2bcadminuser'">
                  <div class="iconBox">
                    <i class="fas fa-handshake"></i>
                  </div>
                  <div class="dataTitle">社保夯实率</div>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else style="background: #fff;">
        <el-empty description="暂未开放"></el-empty>
      </div>
    </div>

    <el-dialog title="设置任务看板权限" :visible.sync="setTaskVisible" width="640px" class="res_dialog enter_dialog">
      <div>
        <el-form class="re_down_form" label-width="100px">
          <el-form-item label="人员:">
            <el-select filterable v-model="setForm.userId" clearable placeholder="" style="width: 300px" size="small" @change="changePerson">
              <el-option v-for="(item, index) in userList" :key="index" :label="item.username" :value="item.userid"></el-option>
            </el-select>
          </el-form-item>
          <div class="taskSetBox">
            <el-form-item label="看板权限:" size="mini">
              <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
              <el-checkbox-group v-model="checkedList" @change="handleCheckedCitiesChange">
                <el-checkbox v-for="item in taskList" :label="item.busiId" :key="item.busiId">{{item.busiName}}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="setTaskVisible = false" size="small">取消</el-button>
        <el-button type="primary" @click="confirmSet" size="small">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css">
</link>
<script>
  import xz from "../../common";
  import checkPermission from '@/utils/permission'; // 权限判断函数
  import signalR from '@/utils/signalR';
  export default {
    data() {
      return {
        listQuery: {
          key: '',
          type: '1',
          pageNum: 1,
          pageSize: 5,
        },
        roletype: localStorage.loginRoletype,
        totalcount: 0,
        Num: 6,
        activeName: '1',
        activeName2: '2',
        loading: false,
        Todolist_EmpWorks: 0, //待审批数量
        remainData: [], //待办列表
        list: this.$store.state.EMP.list,
        list3: this.$store.state.EMP.list3,
        BusiType: '1',
        taskList: [],
        allTaskList: [{
            "url": "",
            "busiId": "1",
            "busiName": "账单",
            "sort": "1"
          },
          {
            "url": "",
            "busiId": "2",
            "busiName": "开票",
            "sort": "2"
          },
          {
            "url": "",
            "busiId": "3",
            "busiName": "算薪",
            "sort": "3"
          },
          {
            "url": "",
            "busiId": "4",
            "busiName": "算薪异常",
            "sort": "4"
          },
          {
            "url": "",
            "busiId": "5",
            "busiName": "待发薪",
            "sort": "5"
          },
          {
            "url": "",
            "busiId": "6",
            "busiName": "发薪异常",
            "sort": "6"
          },
          {
            "url": "",
            "busiId": "7",
            "busiName": "确认零申报",
            "sort": "7"
          },
          {
            "url": "",
            "busiId": "8",
            "busiName": "月度报表",
            "sort": "8"
          },
          {
            "url": "",
            "busiId": "9",
            "busiName": "客户沟通",
            "sort": "9"
          },
          {
            "url": "",
            "busiId": "10",
            "busiName": "入职登记",
            "sort": "10"
          },
          {
            "url": "",
            "busiId": "11",
            "busiName": "登记异常",
            "sort": "11"
          },
          {
            "url": "",
            "busiId": "12",
            "busiName": "发起签约",
            "sort": "12"
          },
          {
            "url": "",
            "busiId": "13",
            "busiName": "个人待签",
            "sort": "13"
          },
          {
            "url": "",
            "busiId": "14",
            "busiName": "签约待审",
            "sort": "14"
          },
          {
            "url": "",
            "busiId": "15",
            "busiName": "签约异常",
            "sort": "15"
          },
          {
            "url": "",
            "busiId": "16",
            "busiName": "商保参保",
            "sort": "16"
          },
          {
            "url": "",
            "busiId": "17",
            "busiName": "商保审核",
            "sort": "17"
          },
          {
            "url": "",
            "busiId": "18",
            "busiName": "商保异常",
            "sort": "18"
          },
          {
            "url": "",
            "busiId": "19",
            "busiName": "离职登记",
            "sort": "19"
          },
          {
            "url": "",
            "busiId": "20",
            "busiName": "离职审批",
            "sort": "20"
          },
          {
            "url": "",
            "busiId": "21",
            "busiName": "商保减保",
            "sort": "21"
          },
          {
            "url": "",
            "busiId": "22",
            "busiName": "社保减保",
            "sort": "22"
          },
          {
            "url": "",
            "busiId": "23",
            "busiName": "商保审核",
            "sort": "23"
          },
          {
            "url": "",
            "busiId": "24",
            "busiName": "社保参保",
            "sort": "24"
          },
          {
            "url": "",
            "busiId": "25",
            "busiName": "参保异常",
            "sort": "25"
          },
          {
            "url": "",
            "busiId": "26",
            "busiName": "自离公告",
            "sort": "26"
          },
          {
            "url": "",
            "busiId": "27",
            "busiName": "用工争议",
            "sort": "27"
          },
          {
            "url": "",
            "busiId": "28",
            "busiName": "复杂退工",
            "sort": "28"
          },
          {
            "url": "",
            "busiId": "29",
            "busiName": "减保异常",
            "sort": "29"
          },
          {
            "url": "",
            "busiId": "30",
            "busiName": "工伤报告",
            "sort": "30"
          },
          {
            "url": "",
            "busiId": "31",
            "busiName": "报告审批",
            "sort": "31"
          },
          {
            "url": "",
            "busiId": "32",
            "busiName": "理赔中",
            "sort": "32"
          },
          {
            "url": "",
            "busiId": "33",
            "busiName": "异常",
            "sort": "33"
          },
          {
            "url": "",
            "busiId": "34",
            "busiName": "证明开具",
            "sort": "34"
          },
          {
            "url": "",
            "busiId": "35",
            "busiName": "福利发放",
            "sort": "35"
          },
          {
            "url": "",
            "busiId": "36",
            "busiName": "人员沟通",
            "sort": "36"
          }
        ],
        permissionLists: [],
        roleName: '',
        isOpen: true,
        numList: {
          beempcont: 0,
          entrymouthcont: 0,
          interttodaycont: 0,
          interttorrcont: 0,
          pendingcont: 0,
          quitcont: 0,
          facetodaycont: 0,
          entrycont: 0,
          beworkcont: 0,
          quitmouthcont: 0,
          entryweekcont: 0,
          quitweekcont: 0
        }, //工作台数据
        workLoading: false,
        shortcutList: [],
        isTest: false,
        needLoading: false,
        setTaskVisible: false,
        checkAll: false, //全选
        isIndeterminate: true,
        checkedList: [],
        checkedTaskList: [],
        userList: [],
        isBtnLoading: false,
        setForm: {
          userId: '',
          list: []
        },
        taskLoading: false,
        userLabel: localStorage.userLabel,
        tipsVisible: false, // 是否显示
        position: 0, // 当前偏移量
        isPaused: false, // 是否暂停
        contentWidth: 0, // 内容宽度
        containerWidth: 0, // 容器宽度
        animationId: null, // 动画 ID
        displayText: '【任务通知】今日待办任务 XXX 个：账单核对 XXX 个、开票 XXX 个、发起签约 XXX 人、发薪 XXX 人、商保待参 XXX 人、工伤报案 XXX 人、工伤理赔 XXX 人、参保异常 XXX 人', // 当前显示的文字
        repeatGap: 30, // 内容移出后延迟重新开始的像素间隔
        pauseOnHover: true, // 是否启用悬停暂停
        speed: 1.2, //
        repeatGap: 30, //
        connection: null,
        hubUrl: 'http://192.168.4.166:8030/yuio/chathub',
      }
    },
    created() {
      this.getOAHomeInit();
      this.getOATodolist();
      this.getJbUserDetail();
      this.getShortcutList();
      this.isTest = location.origin.indexOf('localhost') > -1 || location.origin.indexOf('dev') > -1;
      this.getButtonPower();
      this.GetTaskBoardPermcc();
      this.GetAllLowerUserIdList();
    },
    watch: {
      text(newVal) {
        this.displayText = newVal;
        this.$nextTick(() => {
          this.reinit();
        });
      }
    },
    mounted() {
      // this.initializeConnection();
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible' && this.needLoading) {
          this.needLoading = false;
          this.getOAHomeInit();
          this.getOATodolist();
          this.GetTaskBoardPermcc();
        } else {}
      })
    },
    methods: {
      checkPermission,
      // 获取按钮权限
      getButtonPower() {
        let that = this
        let butQuery = {
          path: '/staging',
          powerEnName: 'staging'
        }
        xz.getbtnPowerIdBypage(butQuery).then(res => {
          if (res.status == 'ok') {
            let resmsg = res.msg
            if (!this.isNull(resmsg)) {
              for (let index = 0; index < resmsg.length; index++) {
                let element = resmsg[index];
                that.permissionLists.push(element.Enname);
              }
              // console.log(that.permissionLists)
            } else {
              this.permissionLists = []
            }
          } else {
            this.$message.error('获取按钮权限出错')
            this.permissionLists = []
          }
        })
      },
      //获取下级人员列表
      GetAllLowerUserIdList() {
        let str = `?pageNum=1&pageSize=1000&Username=`
        xz.ArdCurStatGetFun('GetAllLowerUserIdList', str).then(res => {
          if (res.status == 'ok') {
            this.userList = res.data.date;
          } else {
            this.userList = [];
          }
        })
      },
      isNull(o) {
        // console.log('isnull',o)
        return (
          o == undefined ||
          o == "undefined" ||
          (o + "").indexOf("undefined") > -1 ||
          o == null ||
          o == "" ||
          o == "null" ||
          o == [] ||
          o == "NaN" ||
          o == '[{}]'
        );
      },
      //获取用户详情
      getJbUserDetail() {
        let data = {
          mainuserid: "",
          useridr: Cookies.get("userid-b"),
        }
        xz.getauthJbUserDetailNew(Cookies.get("userid-b"), data).then(res => {
          if (res.status == 'ok') {
            this.roleName = res.msg.StationName;
            this.judgePower();
          } else {
            this.$message.error('系统出错')
            this.roleName = ''
          }
        })
      },
      judgePower() {
        if (this.roleName.indexOf('客服') > -1 || this.roleName.indexOf('管理员') > -1) {
          this.activeName2 = '2';
          this.getNum(2);
        } else if (this.roleName.indexOf('招聘') > -1) {
          this.activeName2 = '1';
          this.getNum(1);
        } else if (this.roleName.indexOf('业务') > -1) {
          this.activeName2 = '3';
          this.getNum(3);
        } else {
          this.activeName2 = '4';
          this.getNum(4);
        }
      },
      handleClickShortcuts(tab) {
        // let a = this.roleName.indexOf('管理员') > -1;
        // if (this.activeName2 == '0') {
        //   let strtype = a ? '管理员客服' : '客服';
        //   this.getNum(strtype);
        // } else if (this.activeName2 == '1') {
        //   let strtype = a ? '管理员招聘' : '招聘';
        //   this.getNum(strtype);
        // } else if (this.activeName2 == '1') {
        //   let strtype = a ? '管理员业务' : '业务';
        //   this.getNum(strtype);
        // } else {
        //   this.getNum('');
        // }
        this.getNum(Number(this.activeName2));
      },
      handleClick() {
        // if (this.activeName == '1') {
        //   this.listQuery = {
        //     key: '',
        //     pageNum: 1,
        //     pageSize: 10
        //   }
        //   this.getOATodolist();
        // } else {
        //   this.listQuery = {
        //     key: '',
        //     pageNum: 1,
        //     pageSize: 10,
        //     scop: this.activeName, //"0我参与的. 1 我发起的" 
        //   }
        //   this.listQuery.scop = this.activeName;
        //   this.WFSearch();
        // }
        this.listQuery.type = this.activeName;
        this.getOATodolist();
      },
      searchHandle() {
        this.getOATodolist();
      },
      getOAHomeInit() {
        if (this.userLabel != 'K') {
          let d = {
            key: '',
            type: '1',
            pageNum: 1,
            pageSize: 10,
          }
          xz.getOATodolist(d, this.roletype).then(res => {
            if (res.status == 'ok') {
              this.Todolist_EmpWorks = res.data.totalcount;
            } else {
              this.Todolist_EmpWorks = 0;
            }
          })
        }
      },
      //取待办列表
      getOATodolist() {
        if (this.userLabel != 'K') {
          this.loading = true;
          xz.getOATodolist(this.listQuery, this.roletype).then(res => {
            if (res.status == 'ok') {
              this.remainData = res.data.listRet;
              this.totalcount = res.data.totalcount;
              this.loading = false;
            } else {
              this.remainData = [];
              this.totalcount = 0;
              this.loading = false;
            }
          })
        }
      },
      toHandel(item) {
        this.needLoading = true;
        if (item.WebUrl.indexOf('tePaymentDtl') > -1) {
          if (item.FK_Flow == '1') {
            item.WebUrl = item.WebUrl + '&type=dtl&activeName=核销记录&from=staging'
          } else {
            item.WebUrl = item.WebUrl + '&type=approve&activeName=财务核销&from=staging'
          }
        }
        window.open(item.WebUrl, "_blank");

      },
      currentChange() {
        this.getOATodolist();
      },
      //已审批/我发起的
      WFSearch() {
        this.loading = true;
        xz.WFSearch(this.listQuery, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.remainData = res.data.listRet;
            this.totalcount = 0;
            this.loading = false;
          } else {
            this.remainData = [];
            this.totalcount = 0;
            this.loading = false;
          }
        })
      },
      //获取招聘数据
      getNum(Type) {
        let info = {
          beempcont: 0,
          entrymouthcont: 0,
          interttodaycont: 0,
          interttorrcont: 0,
          pendingcont: 0,
          quitcont: 0,
          facetodaycont: 0,
          entrycont: 0,
          beworkcont: 0,
          quitmouthcont: 0,
          entryweekcont: 0,
          quitweekcont: 0
        }
        this.numList = info;
        this.workLoading = true;
        let str = `Workbench/GetPersonnelChangesData?UserId=${Cookies.get("userid-b")}&Type=${Type}`
        xz.rcGetFun(str).then(res => {
          if (res.status == 'ok') {
            this.numList = res.data;
            this.workLoading = false;
          } else {
            this.numList = info;
            this.workLoading = false;
            this.$message.error('获取工作台数据出错')
          }
        })
      },
      toSignupList() {
        this.$router.push({
          path: '/signupList'
        })
      },
      goto(path) {
        this.$router.push({
          path: path
        })
      },
      gotoOut() {
        let id = Cookies.get("userid-b");
        window.open("https://large.joball.net/#/HomeView?isEmp=" + id, "_blank");
      },
      gotoOutSSC() {
        let id = Cookies.get("userid-b");
        window.open("https://ssc.joball.net/#/index?isEmp=" + id, "_blank");
      },
      gotoOut2() {
        window.open("http://183.6.70.7:21789/JobCRM/");
      },
      gotoQKL() {
        this.$router.push({
          path: '/onChainManage'
        })
      },
      gotoHLS() {
        this.$router.push({
          path: '/basicDataList'
        })
      },
      getShortcutList() {
        this.shortcutList = [];
        let activeRouter = JSON.parse(localStorage.router);
        activeRouter.forEach(element => {
          if (element.powername == '雇员') {
            let data = {
              name: '招聘管理',
              path: '/signupList',
              icon: 'fas fa-address-book'
            }
            this.shortcutList.push(data)
            let data2 = {
              name: '商保增减员',
              path: '/declare',
              icon: 'fas fa-shield-alt'
            }
            this.shortcutList.push(data2)
            let data3 = {
              name: '电子签约',
              path: '/eleSigning',
              icon: 'fas fa-file-signature'
            }
            this.shortcutList.push(data3)
          }
          if (element.powername == '薪酬') {
            let data = {
              name: '发薪',
              path: '/calcSalary',
              icon: 'fas fa-wallet'
            }
            this.shortcutList.push(data)
          }
          if (element.powername == '报表') {
            element.children.forEach(e => {
              if (e.powername == '利润报表') {
                let data = {
                  name: '利润表',
                  path: '/basicReport',
                  icon: 'fas fa-chart-pie'
                }
                this.shortcutList.push(data)
              }
            });
          }
        });
      },
      //获取任务看板列表和数量
      GetTaskBoardPermcc() {
        this.taskLoading = true;
        let str = `?id=1&Userid=${Cookies.get("userid-b")}`
        xz.ArdCurStatGetFun('GetTaskBoardPermCC1', str).then(res => {
          if (res.status == 'ok') {
            // if (this.roletype == '0383e791-72fd-4edc-aa70-2bcadminuser') {
            //   this.taskList = this.allTaskList;
            // } else {
            //   this.taskList = res.data;
            // }
            this.taskList = res.data;
            let str2 = `?BusiType=${Number(this.BusiType)}`
            xz.ArdCurStatGetFun('GetTaskBoard', str2).then(r => {
              if (r.status == 'ok') {
                // if (res.data.length > 0) {
                //   this.taskList = this.mergeBySortSimple(this.taskList, r.data);
                //   this.generateNoticeText();
                // } else {
                //   this.taskList = r.data;
                // }
                this.taskList = r.data;
                this.tipsVisible = true;
                this.$nextTick(() => {
                  this.init();
                });
                this.generateNoticeText();
                if (r.data.length == 0) {
                  this.tipsVisible = false;
                }
                this.taskLoading = false;
              } else {
                this.taskLoading = false;
                this.$message.error(`获取任务面板数据出错：${r.msg}`)
              }
            })
          } else {
            this.checkedList = [];
          }
        })
      },
      mergeBySortSimple(list1, list2) {
        const result = list1.map(item => ({
          ...item,
          val: 0
        }));

        list2.forEach(item2 => {
          const found = result.find(item1 => item1.sort === item2.sort);
          if (found) {
            found.val = item2.val;
          } else {
            found.val = 0;
            console.warn(`sort ${item2.sort} 在 list1 中未找到`);
          }
        });
        return result;
      },
      //生成通知文本
      generateNoticeText() {
        // 1. 筛选 val > 0 的数据
        const activeItems = this.taskList.filter(item => item.val > 0);
        // 2. 如果没有数据，返回默认提示
        if (activeItems.length === 0) {
          this.displayText = '【任务通知】今日暂无待办任务 🎉'
        } else {
          // 3. 统计总数
          const total = activeItems.reduce((sum, item) => sum + item.val, 0);
          // 4. 构建各部分文本
          const parts = activeItems.map(item => {
            const name = item.busiName;
            const val = item.val;
            // 根据名称添加合适的量词
            return `${name}：${val}个`;
          });
          this.displayText = `【任务通知】今日待办任务 ${total} 个：${parts.join('、')}`
          // 5. 组装最终文本
          // this.updateText(`【任务通知】今日待办任务 ${total} 个：${parts.join('、')}个`)
        }
      },
      changeTab() {},
      assignTasks() {
        this.needLoading = true;
        window.open('/assignTasks', "_blank");
      },
      //设置下属权限
      setTaskList() {
        this.setForm.userId = '';
        this.checkedList = [];
        this.setTaskVisible = true;
      },
      changePerson(val) {
        let str = `?id=1&Userid=${val}`
        xz.ArdCurStatGetFun('GetTaskBoardPermCC1', str).then(res => {
          if (res.status == 'ok') {
            this.checkedList = res.data.map(item => item.busiId);
            // 同步更新全选/半选状态
            const checkedCount = this.checkedList.length;
            this.checkAll = checkedCount === this.taskList.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.taskList.length;
          }
        })
      },
      //全选任务模块
      handleCheckAllChange(val) {
        this.checkedList = val ? this.taskList.map(item => item.busiId) : [];
        this.isIndeterminate = false;
      },
      //勾选任务模块
      handleCheckedCitiesChange(val) {
        let checkedCount = val.length;
        // 更新全选框的状态
        this.checkAll = checkedCount === this.taskList.length;
        // 更新半选状态
        this.isIndeterminate = checkedCount > 0 && checkedCount < this.taskList.length;
      },
      confirmSet() {
        this.checkedTaskList = this.taskList.filter(item =>
          this.checkedList.includes(item.busiId)
        );
        this.setForm.list = this.checkedTaskList;
        this.isBtnLoading = true;
        xz.ArdCurStat(this.setForm, 'UpdataUserTaskBoard').then(res => {
          if (res.status == 'ok') {
            this.setTaskVisible = false;
            this.$message.success('保存成功！');
            this.GetTaskBoardPermcc();
            this.isBtnLoading = false;
          } else {
            this.$message.error(res.msg);
            this.isBtnLoading = false;
          }
        })
      },
      /** 初始化 */
      init() {
        this.updateDimensions();
        // 从右侧开始进入
        this.position = this.containerWidth;
        this.$refs.scrollContent.style.transform = `translateX(${this.position}px)`;
        this.startAnimation();
      },

      /** 重新初始化（内容变化或窗口变化时） */
      reinit() {
        this.stopAnimation();
        this.updateDimensions();
        // 从右侧开始进入
        this.position = this.containerWidth;
        this.$refs.scrollContent.style.transform = `translateX(${this.position}px)`;
        this.startAnimation();
      },

      /** 更新尺寸 */
      updateDimensions() {
        const content = this.$refs.scrollContent;
        const wrap = this.$refs.scrollWrap;
        if (!content || !wrap) return;
        // 临时重置 transform 获取真实宽度
        content.style.transform = 'translateX(0px)';
        this.contentWidth = content.scrollWidth;
        this.containerWidth = wrap.clientWidth;
        // 恢复位置
        content.style.transform = `translateX(${this.position}px)`;
      },

      /** 启动动画 */
      startAnimation() {
        if (this.animationId) {
          cancelAnimationFrame(this.animationId);
          this.animationId = null;
        }
        this.animate();
      },

      /** 停止动画 */
      stopAnimation() {
        if (this.animationId) {
          cancelAnimationFrame(this.animationId);
          this.animationId = null;
        }
      },

      /** 动画帧 */
      animate() {
        if (this.isPaused) {
          this.animationId = requestAnimationFrame(this.animate);
          return;
        }

        // 左移
        this.position -= this.speed;

        // 当内容完全移出左侧，重置到右侧重新进入
        const threshold = this.contentWidth + this.repeatGap;
        if (Math.abs(this.position) >= threshold) {
          this.position = this.containerWidth;
        }

        this.$refs.scrollContent.style.transform = `translateX(${this.position}px)`;

        this.animationId = requestAnimationFrame(this.animate);
      },

      /** 关闭通知 */
      handleClose() {
        this.tipsVisible = false;
        this.stopAnimation();
      },

      /** 暂停滚动 */
      pause() {
        this.isPaused = true;
      },

      /** 恢复滚动 */
      resume() {
        this.isPaused = false;
      },

      /** 更新文字（外部调用） */
      updateText(newText) {
        if (!newText || typeof newText !== 'string') return;
        this.displayText = newText;
        this.$nextTick(() => {
          this.reinit();
        });
      },
      toSysSet() {
        this.needLoading = true;
        window.open('/taskSysSet', "_blank");
      },
      toTaskItem(item) {
        if (item.busiId == '4') {
          window.open(`/calcSalary`, "_blank");
        } else if (item.busiId == '5') {
          window.open(`payment?activeName=待发薪&projectName=`, "_blank");
        } else if (item.busiId == '6') {
          window.open(`payment?activeName=发薪失败`, "_blank");
        } else {
          window.open(`/taskDtl?busiName=${item.busiName}`, "_blank");
        }
      },
      // 初始化连接
      async initializeConnection() {
        // 创建连接实例
        this.connection = signalR.createConnection(this.hubUrl, {
          accessTokenFactory: () => localStorage.getItem('token') // 身份验证（可选）
        })

        // 注册接收消息的回调
        this.connection.on('ReceiveMessage', (user, message) => {
          console.log('ssas', user, message)
        })

        // 启动连接
        const success = await signalR.startConnection(this.connection)
        if (!success) {
          alert('连接服务器失败，请检查网络')
        }

        // 监听连接关闭事件
        this.connection.onclose(() => {
          console.log('连接已断开')
        })
      },
      // 发送消息
      async sendMessage() {
        try {
          // 调用服务端 Hub 方法（假设方法名为 SendMessage）
          await this.connection.invoke('RegisterUser', Cookies.get("userid-b"))
          this.message = ''
        } catch (err) {
          console.error('发送消息失败:', err)
          alert('发送失败，请重试')
        }
      }
    },
    beforeUnmount() {
      // 组件销毁前关闭连接
      signalR.stopConnection(this.connection)
    },
    beforeDestroy() {
      this.stopAnimation();
    },
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    // background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
    padding-top: 10px;
  }

  .stagingBox {
    // width: 90%;
    // max-width: 720px;
    margin-bottom: 20px;
    border: 1px solid #c1c1c1;
    padding: 10px 20px;
    background: white;
    border-radius: 20px;
    box-shadow: 0 6px 18px rgba(0, 40, 30, 0.02);
    border: 1px solid #edf1f7;
    background: #f9fdfb;
    min-height: 215px;
  }

  .stagingBox:hover {
    background: #ffffff;
    border-color: #aad6c8;
    box-shadow: 0 12px 30px rgba(25, 189, 146, 0.06);
  }

  .shortcuts {
    // width: 25%;
    width: 260px;
    padding: 10px 20px;
    border: 1px solid #c1c1c1;
    background: white;
    border-radius: 20px;
    margin-bottom: 20px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.02);
    border: 1px solid #edf1f7;
    background: #f9fdfb;
  }

  .shortcuts:hover {
    background: #ffffff;
    border-color: #aad6c8;
    box-shadow: 0 12px 30px rgba(25, 189, 146, 0.06);
  }

  .tabbox {
    width: 100%;
    justify-content: space-between;
    margin-bottom: 15px;
  }

  .approveItem {
    margin-bottom: 20px;
  }

  .approveTitle {
    padding: 3px 10px;
    border-radius: 8px;
    margin-right: 15px;
    color: #fff;
  }

  .warning {
    background-color: rgba(229, 115, 51, 1);
  }

  .success {
    background-color: #67C23A;
  }

  .dataBoard {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
  }

  .dataItem {
    width: 33%;
    text-align: center;
    padding: 20px 0;
  }

  /* 快捷入口网格 (在第四个大方框内) */
  .quick_grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
    margin-top: 5px;
  }

  .quick_item {
    // width: 45%;
    background: #eef9f4;
    border-radius: 18px;
    padding: 6px 0;
    margin-bottom: 5px;
    text-align: center;
    color: #1e2e4a;
    font-size: 12px;
    font-weight: 400;
    transition: 0.15s;
    border: 1px solid #d4ece2;
    cursor: pointer;
  }

  .quick_item i {
    display: block;
    font-size: 22px;
    margin-bottom: 6px;
    color: #19bd92;
  }

  .quick_item:hover {
    background: #ffffff;
    border-color: #b8cef0;
    box-shadow: 0 4px 10px rgba(0, 20, 40, 0.04);
  }

  .taskItem {
    width: 60px;
    text-align: center;
    padding: 10px 0;
    // margin-right: 15px;
    width: 11%;
    text-align: center;
  }

  .dataNum {
    // font-weight: 600;
    font-size: 18px;
  }

  .taskNum {
    // font-weight: 600;
    font-size: 16px;
    color: #1E27B9;
  }

  .custNum {
    // font-weight: 600;
    font-size: 16px;
    color: #E46A12;
  }

  .AINum {
    // font-weight: 600;
    font-size: 16px;
    color: #42C720
  }

  .dataTitle {
    margin-top: 10px;
    font-size: 14px;
  }

  .taskTitle {
    margin-top: 5px;
    font-size: 13px;
  }

  .messageTitle {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 10px;
  }

  .iconBox {
    font-size: 32px;
  }

  .taskR {
    height: 40px;
  }

  .taskSetBox {
    padding-top: 20px;
  }

  .notice-wrapper {
    position: relative;
    width: 92%;
    max-width: 1180px;
    background: #f5e6c8;
    border-radius: 12px;
    padding: 6px 20px 6px 24px;
    box-shadow: 0 8px 30px rgba(0, 20, 50, 0.35);
    overflow: hidden;
    display: flex;
    align-items: center;
    transition: opacity 0.3s ease;
    margin-bottom: 10px;
  }

  .notice-icon {
    flex-shrink: 0;
    margin-right: 16px;
    font-size: 16px;
    color: #ffd700;
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .notice-icon span {
    font-size: 14px;
    font-weight: 600;
    color: #000;
    letter-spacing: 1px;
  }

  .scroll-wrap {
    flex: 1;
    overflow: hidden;
    position: relative;
    height: 24px;
  }

  .scroll-content {
    display: inline-block;
    white-space: nowrap;
    font-size: 14px;
    color: rgb(65, 64, 64);
    font-weight: 500;
    letter-spacing: 0.5px;
    line-height: 24px;
    will-change: transform;
  }

  .notice-close {
    flex-shrink: 0;
    margin-left: 16px;
    width: 24px;
    height: 24px;
    border: none;
    background: rgba(255, 255, 255, 0.15);
    border-radius: 50%;
    color: #000;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    cursor: pointer;
    transition: background 0.25s;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .notice-close:hover {
    background: rgba(255, 255, 255, 0.30);
  }

  .notice-close:active {
    transform: scale(0.92);
  }

  /* 响应式 */
  @media (max-width: 640px) {
    .notice-wrapper {
      width: 94%;
      padding: 12px 44px 12px 16px;
      border-radius: 8px;
    }

    .notice-icon {
      font-size: 18px;
      margin-right: 10px;
    }

    .notice-icon span {
      font-size: 12px;
    }

    .scroll-content {
      font-size: 14px;
      line-height: 32px;
    }

    .scroll-wrap {
      height: 32px;
    }

    .notice-close {
      width: 24px;
      height: 24px;
      font-size: 15px;
      line-height: 24px;
      margin-left: 10px;
    }
  }

  .left_box {
    width: 66%;
    // max-width: 800px;
  }

  .right_box {
    width: 33%;
    // max-width: 400px;
    margin-left: 20px;
  }

  .emptyTip {
    background: #eef9f4;
    border-radius: 40px;
    padding: 12px 18px;
    border: 1px dashed #9ad0be;
    display: flex;
    align-items: center;
    gap: 10px;
    color: #1d3b30;
    font-size: 14px;
    margin: 36px 0 48px 0;
  }

  .taskIconItem {
    margin-right: 10px;
  }

  .taskIconItem i {
    background: linear-gradient(145deg, #2563eb, #3b82f6);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    filter: drop-shadow(0 4px 6px rgba(37, 99, 235, 0.15));
  }

  .taskIconItem:hover {
    transform: translateY(-2px);
    box-shadow: 0 20px 40px rgba(0, 20, 40, 0.12);
  }
</style>
<style>
  .page_staging .el-input--small .el-input__icon {
    line-height: 32px;
    height: 32px;
  }

  .taskSetBox .el-checkbox {
    width: 90px;
  }
</style>